import React from "react";
import { Form, Radio, Row, Col } from "antd";
import { useIntl } from "react-intl";
import {
  getFormItemLabel,
  getFormItemVaidation,
} from "../../../components/util/helpers";

const EmployeeType = (props) => {
  const intl = useIntl();
  const label = getFormItemLabel(intl, "employee", "employee_type_id", null);
  const arr = ["required"];
  const rules = getFormItemVaidation(intl, label, arr);
  return (
    <Row>
      <Col span={24}>
        <Form.Item
          name={"is_professional_employee"}
          rules={rules}
          wrapperCol={{ span: 24 }}
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Radio.Group style={{ display: "flex", justifyContent: "center" }}>
            <Radio.Button key={1} value={"standard"}>
              {intl.formatMessage({
                id: "app.employees.standardEmployee",
              })}
            </Radio.Button>
            <Radio.Button key={2} value={"professional"}>
              {intl.formatMessage({
                id: "app.employees.professionalEmployee",
              })}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default EmployeeType;
